import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gradient-spinner",
  "use": "gradient-spinner-usage",
  "viewBox": "0 0 102 102",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 102 102\" id=\"gradient-spinner\"><circle cx=\"51\" cy=\"51\" r=\"50\" stroke=\"url(#gradient-spinner_a)\" /><defs><linearGradient id=\"gradient-spinner_a\" x1=\"100%\" x2=\"0%\" y1=\"0%\" y2=\"0%\"><stop offset=\"0\" stop-color=\"#A5FF36\" /><stop offset=\".5\" stop-color=\"#A5FF36\" stop-opacity=\".2\" /></linearGradient></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol